module.exports = __webpack_public_path__ + "static/media/H_J.efd8ce9a.png";